import apiClient from "@/shared/services/api/apiClient.js";

export const getCentralizedResumeDatabase = async (
  page = 1,
  limit = 25,
  search = ""
) => {
  return apiClient.get("/resumes", {
    params: {
      page,
      limit,
      search,
    },
  });
};